export default __webpack_public_path__ + "99e85f0c02144eeec0816093fe30b56a.woff";